// extracted by mini-css-extract-plugin
export default {"container":"Pd5T4odyKWlEyroBBcWL","title":"gXyroGpT49odISF5d1xT","valueContainer":"STpEIRPwi0w3l0zKWRt4","value":"CUcbHZEU9FdtAzNN5toj","comparingInfo":"nB1KD6Ut4hVaIigw4Zpb"};